export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  traitManager.addType('input-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue =
        this.model.get('value') !== ''
          ? this.model.get('value').replaceAll("'", '"').replaceAll('\\"', '"')
          : '';
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      if (field) {
        attrs['name'] = field.fieldName;
        attrs['placeholder'] = field.placeholder.en;
        if (component.is('input')) {
          attrs['type'] = field.type;
        }
        if (component.is('file')) {
          component.collection.forEach((comp) => {
            if (comp.getAttributes()['type'] === 'hidden') {
              const attrs = { ...comp.get('attributes') };
              attrs['name'] = field.fieldName;
              comp.set('attributes', attrs);
            }
          });
        }
        if (component.is('select')) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
          delete attrs['multiple'];
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('input')) {
          attrs['type'] = '';
        }
        if (component.is('file')) {
          component.collection.forEach((comp) => {
            if (comp.getAttributes()['type'] === 'hidden') {
              const attrs = { ...comp.get('attributes') };
              attrs['name'] = '';
              comp.set('attributes', attrs);
            }
          });
        }
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            return optIdValueJson.fieldName === component.getAttributes()['name'];
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
  traitManager.addType('select-current-user-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue =
        this.model.get('value') !== ''
          ? this.model.get('value').replaceAll("'", '"').replaceAll('\\"', '"')
          : '';
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      if (field) {
        if (component.is('select') && field.fieldTitle.en) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const componentValue = component.get('currentUserCollectionField');
        const componentValueString = componentValue ? componentValue.replaceAll('\\"', '"') : '';
        const componentValueJson = componentValueString ? JSON.parse(componentValueString) : '';
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            return (
              componentValueJson &&
              optIdValueJson &&
              optIdValueJson.fieldName === componentValueJson.fieldName
            );
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
  traitManager.addType('select-current-tenant-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue =
        this.model.get('value') !== ''
          ? this.model.get('value').replaceAll("'", '"').replaceAll('\\"', '"')
          : '';
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      if (field) {
        if (component.is('select') && field.fieldTitle) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const componentValue = component.get('currentTenantCollectionField');
        const componentValueString = componentValue ? componentValue.replaceAll('\\"', '"') : '';
        const componentValueJson = componentValueString ? JSON.parse(componentValueString) : '';
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            return (
              componentValueJson &&
              optIdValueJson &&
              optIdValueJson.fieldName === componentValueJson.fieldName
            );
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });

  traitManager.addType('select-current-user-settings-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue =
        this.model.get('value') !== ''
          ? this.model.get('value').replaceAll("'", '"').replaceAll('\\"', '"')
          : '';
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      if (field) {
        if (component.is('select') && field.fieldTitle) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const componentValue = component.get('currentUserSettingsCollectionField');
        const componentValueString = componentValue ? componentValue.replaceAll('\\"', '"') : '';
        const componentValueJson = componentValueString ? JSON.parse(componentValueString) : '';
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            return (
              componentValueJson &&
              optIdValueJson &&
              optIdValueJson.fieldName === componentValueJson.fieldName
            );
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
  traitManager.addType('select-current-sub-tenant-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      for (let i = 0; i < options.length; i++) {
        let name = options[i].name;
        let value = options[i].id;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue =
        this.model.get('value') !== ''
          ? this.model.get('value').replaceAll("'", '"').replaceAll('\\"', '"')
          : '';
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      if (field) {
        if (component.is('select') && field.fieldTitle) {
          attrs['data-placeholder'] = `Choose a ${field.fieldTitle.en}`;
        }
      } else {
        attrs['name'] = '';
        attrs['placeholder'] = '';
        if (component.is('select')) {
          attrs['data-placeholder'] = '';
        }
      }
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const componentValue = component.get('currentSubTenantCollectionField');
        const componentValueString = componentValue ? componentValue.replaceAll('\\"', '"') : '';
        const componentValueJson = componentValueString ? JSON.parse(componentValueString) : '';
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            return (
              componentValueJson &&
              optIdValueJson &&
              optIdValueJson.fieldName === componentValueJson.fieldName
            );
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
  traitManager.addType('dropdown-label-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const input = document.createElement('select');
      const collectionFields = [];
      const referenceFields = [];
      const derivedFields = [];
      for (let i = 0; i < options.length; i++) {
        if (options[i].optionType === 'fields') collectionFields.push(options[i]);
        if (options[i].optionType === 'reference_field') referenceFields.push(options[i]);
        if (options[i].optionType === 'derived_fields') derivedFields.push(options[i]);
      }
      const optGroupFields = getOptionGroupFromFields(collectionFields, 'Fields');
      const optGroupRefFields = getOptionGroupFromFields(referenceFields, 'Reference Fields');
      const optGroupDerivedFields = getOptionGroupFromFields(derivedFields, 'Derived Fields');
      input.append(optGroupFields);
      input.append(optGroupRefFields);
      input.append(optGroupDerivedFields);
      return input;
    },

    onEvent({ elInput, component }) {
      const attrs = { ...component.get('attributes') };
      let fieldValue = '';
      const value = this.model.get('value');
      if (value.includes('functionType')) {
        fieldValue = value;
      } else if (value !== '') {
        fieldValue = value.replaceAll("'", '"').replaceAll('\\"', '"');
      }
      const field = fieldValue ? JSON.parse(fieldValue) : {};
      let labelField = '';
      if (field) {
        if (field.optionType === 'derived_fields') {
          labelField = JSON.stringify(field);
        } else labelField = field.fieldName ? field.fieldName : '';
      }
      attrs['label-field'] = labelField;
      this.target.set('attributes', attrs);
    },

    onUpdate({ elInput, component }) {
      const opts = this.model.get('options') || [];
      if (opts !== undefined) {
        const selectedValue = opts.find((opt) => {
          if (opt.id !== '') {
            const optIdValue = opt.id;
            const optIdValueString = optIdValue ? optIdValue.replaceAll('\\"', '"') : '';
            const optIdValueJson = optIdValueString ? JSON.parse(optIdValueString) : '';
            let labelField = component.getAttributes()['label-field'];
            if (labelField && labelField.includes('functionType')) {
              return JSON.stringify(optIdValueJson) === labelField.replaceAll('\\"', '"');
            }
            return optIdValueJson.fieldName === labelField;
          }
        });
        elInput.value = selectedValue ? selectedValue.id : '';
      }
    },
  });
}

const getOptionGroupFromFields = (fields, label) => {
  const optgroup = document.createElement('optgroup');
  if (fields.length) {
    optgroup.setAttribute('label', label);
    fields.forEach((opt) => {
      let name = opt.name;
      let value = opt.id;
      let option = document.createElement('option');
      option.text = name;
      option.value = value;
      optgroup.append(option);
    });
  }
  return optgroup;
};
